// src/pages/dashboard/DashboardPage.tsx
import React, { useState } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import "../assets/css/dashboard.css";


import { useDashboard } from "../hooks/dashboard/useDashboard";
import DashboardToolbar from "../components/Dashboard2/toolbar/DashboardToolbar";
import DashboardGrid from "../components/Dashboard2/grid/DashboardGrid";
import AddWidgetModal from "../components/Dashboard2/modal/AddWidgetModal";
import ConfirmDeleteModal from "../components/Dashboard2/modal/ConfirmDeleteModal";

import type { DashboardWidget } from "../types/dashboard/dashboard.types";
import { useTranslate } from "../hooks/LanguageProvider";

export default function DashboardPage() {
    const id_dashboard = 1;
    const [showModal, setShowModal] = useState(false);
    const [widgetToDelete, setWidgetToDelete] = useState<DashboardWidget | null>(null);

    // ✅ Edit mode ON/OFF
    const [isEditMode, setIsEditMode] = useState(false);

    const { translate } = useTranslate();

    const {
        widgets,
        layouts,
        loading,
        saveStatus,
        canSave,
        setCurrentBreakpoint,
        onLayoutChange,
        addNewWidget,
        removeWidget,
        save,
    } = useDashboard(id_dashboard);

    return (
        <Container fluid className="mt-4">

            <button
                type="button"
                className={`edit-float-btn ${isEditMode ? "active" : ""}`}
                onClick={async () => {
                    if (isEditMode) await save(); // optionnel auto-save
                    setIsEditMode((v) => !v);
                }}
                title={isEditMode ? translate("Done") : translate("Edit")}
            >
                <i className={`ri-${isEditMode ? "check-line" : "edit-line"}`}></i>
                <span className="label">
                    {isEditMode ? translate("Done") : translate("Edit")}
                </span>
            </button>

            {isEditMode && (
                <Row className="align-items-center mb-3">
                    <Col xs={12} md={6}>
                        <h4 className="mb-2 mb-md-0 d-flex align-items-center gap-2">
                            <i className="fas fa-edit text-primary"></i>
                            {translate("Edit dashboard")}
                        </h4>
                    </Col>

                    <Col xs={12} md={6} className="d-flex justify-content-md-end gap-2">
                        <DashboardToolbar
                            onAdd={() => setShowModal(true)}
                            onSave={save}
                            saveStatus={saveStatus}
                            canSave={canSave}
                        />
                    </Col>
                </Row>
            )}

            {/* Grid */}
            {loading ? (
                <div>Chargement...</div>
            ) : (
                <DashboardGrid
                    widgets={widgets}
                    layouts={layouts}
                    isEditMode={isEditMode}
                    onLayoutChange={onLayoutChange}
                    onBreakpointChange={(bp: any) => setCurrentBreakpoint(bp as any)}
                    onRequestDelete={(widget) => setWidgetToDelete(widget)}
                />
            )}

            {/* Confirm Delete Modal */}
            <ConfirmDeleteModal
                show={!!widgetToDelete}
                onCancel={() => setWidgetToDelete(null)}
                onConfirm={async () => {
                    if (!widgetToDelete) return;
                    await removeWidget(widgetToDelete.id_widget);
                    setWidgetToDelete(null);
                }}
                message={`${translate("Do you really want to delete")} "${widgetToDelete?.type}" ?`}
            />

            {/* Add Widget Modal */}
            <AddWidgetModal
                show={showModal}
                handleClose={() => setShowModal(false)}
                handleAddWidget={async (content: string, type: string) => {
                    await addNewWidget(content, type);
                    setShowModal(false);
                }}
            />
        </Container>
    );
}
